import z from "zod";

export const modals = {
  exit: {
    title: "Discard Changes",
    description: "Changes will not be saved. Do you want to proceed?",
  },
  error: {
    title: "Unable to Save Dispatch Settings",
    description: "There is an error in one of the fields submitted. Please double check your inputs and try again.",
  },
};

export const formSchema = z
  .object({
    enabledAutomaticDispatch: z.boolean(),
    dispatchTier1Time: z.string().optional(),
    dispatchTier1Timeframe: z.string(),
    dispatchTier2Time: z.string().optional(),
    dispatchTier2Timeframe: z.string(),
    dispatchTier3Time: z.string().optional(),
    dispatchTier3Timeframe: z.string(),
    dispatchSpecialEventTier0Time: z.string().optional(),
    dispatchSpecialEventTier0Timeframe: z.string(),
    dispatchSpecialEventTier1Time: z.string().optional(),
    dispatchSpecialEventTier1Timeframe: z.string(),
    dispatchSpecialEventTier2Time: z.string().optional(),
    dispatchSpecialEventTier2Timeframe: z.string(),
    dispatchSpecialEventTier3Time: z.string().optional(),
    dispatchSpecialEventTier3Timeframe: z.string(),
    dispatchAutoOwnFleetRetryCount: z.string().min(1, "Field is required and can't be empty."),
    dispatchAutoPrivateNetworkRetryCount: z.string().min(1, "Field is required and can't be empty."),
    enabledHoldBeforeDispatch: z.boolean(),
    dispatchHoldBeforeDispatchTime: z.string().optional(),
    dispatchHoldBeforeDispatchTimeframe: z.string(),
    dispatchAsapHoldBeforeDispatchTime: z.string().optional(),
    dispatchAsapHoldBeforeDispatchTimeframe: z.string(),
  })
  .refine((data) => !(data.enabledAutomaticDispatch && !data.dispatchTier1Time), {
    message: "Field is required and can't be empty.",
    path: ["dispatchTier1Time"],
  })
  .refine(
    (data) =>
      !(
        data.enabledAutomaticDispatch &&
        data.dispatchTier1Timeframe === "hour" &&
        data.dispatchTier1Time &&
        Number(data.dispatchTier1Time) < 4
      ),
    {
      message: "Minimum dispatch time is 4 hours before pickup.",
      path: ["dispatchTier1Time"],
    }
  )
  .refine((data) => !(data.enabledAutomaticDispatch && !data.dispatchTier2Time), {
    message: "Field is required and can't be empty.",
    path: ["dispatchTier2Time"],
  })
  .refine(
    (data) =>
      !(
        data.enabledAutomaticDispatch &&
        data.dispatchTier2Timeframe === "hour" &&
        data.dispatchTier2Time &&
        Number(data.dispatchTier2Time) < 4
      ),
    {
      message: "Minimum dispatch time is 4 hours before pickup.",
      path: ["dispatchTier2Time"],
    }
  )
  .refine((data) => !(data.enabledAutomaticDispatch && !data.dispatchTier3Time), {
    message: "Field is required and can't be empty.",
    path: ["dispatchTier3Time"],
  })
  .refine(
    (data) =>
      !(
        data.enabledAutomaticDispatch &&
        data.dispatchTier3Timeframe === "hour" &&
        data.dispatchTier3Time &&
        Number(data.dispatchTier3Time) < 4
      ),
    {
      message: "Minimum dispatch time is 4 hours before pickup.",
      path: ["dispatchTier3Time"],
    }
  )
  .refine((data) => !(data.enabledAutomaticDispatch && !data.dispatchSpecialEventTier0Time), {
    message: "Field is required and can't be empty.",
    path: ["dispatchSpecialEventTier0Time"],
  })
  .refine(
    (data) =>
      !(
        data.enabledAutomaticDispatch &&
        data.dispatchSpecialEventTier0Timeframe === "hour" &&
        data.dispatchSpecialEventTier0Time &&
        Number(data.dispatchSpecialEventTier0Time) < 4
      ),
    {
      message: "Minimum dispatch time is 4 hours before pickup.",
      path: ["dispatchSpecialEventTier0Time"],
    }
  )
  .refine((data) => !(data.enabledAutomaticDispatch && !data.dispatchSpecialEventTier1Time), {
    message: "Field is required and can't be empty.",
    path: ["dispatchSpecialEventTier1Time"],
  })
  .refine(
    (data) =>
      !(
        data.enabledAutomaticDispatch &&
        data.dispatchSpecialEventTier1Timeframe === "hour" &&
        data.dispatchSpecialEventTier1Time &&
        Number(data.dispatchSpecialEventTier1Time) < 4
      ),
    {
      message: "Minimum dispatch time is 4 hours before pickup.",
      path: ["dispatchSpecialEventTier1Time"],
    }
  )
  .refine((data) => !(data.enabledAutomaticDispatch && !data.dispatchSpecialEventTier2Time), {
    message: "Field is required and can't be empty.",
    path: ["dispatchSpecialEventTier2Time"],
  })
  .refine(
    (data) =>
      !(
        data.enabledAutomaticDispatch &&
        data.dispatchSpecialEventTier2Timeframe === "hour" &&
        data.dispatchSpecialEventTier2Time &&
        Number(data.dispatchSpecialEventTier2Time) < 4
      ),
    {
      message: "Minimum dispatch time is 4 hours before pickup.",
      path: ["dispatchSpecialEventTier2Time"],
    }
  )
  .refine((data) => !(data.enabledAutomaticDispatch && !data.dispatchSpecialEventTier3Time), {
    message: "Field is required and can't be empty.",
    path: ["dispatchSpecialEventTier3Time"],
  })
  .refine(
    (data) =>
      !(
        data.enabledAutomaticDispatch &&
        data.dispatchSpecialEventTier3Timeframe === "hour" &&
        data.dispatchSpecialEventTier3Time &&
        Number(data.dispatchSpecialEventTier3Time) < 4
      ),
    {
      message: "Minimum dispatch time is 4 hours before pickup.",
      path: ["dispatchSpecialEventTier3Time"],
    }
  )
  .refine((data) => !(data.enabledHoldBeforeDispatch && !data.dispatchHoldBeforeDispatchTime), {
    message: "Field is required and can't be empty.",
    path: ["dispatchHoldBeforeDispatchTime"],
  })
  .refine((data) => !(data.enabledHoldBeforeDispatch && !data.dispatchAsapHoldBeforeDispatchTime), {
    message: "Field is required and can't be empty.",
    path: ["dispatchAsapHoldBeforeDispatchTime"],
  });
